import React from "react";
import { trackEvent } from "@/lib/analytics";

/** Book Now link that tracks a book_click event before navigating out. */
export function BookLink({ label = "Book Now", href, className = "", children, ...rest }) {
  const onClick = () => trackEvent("book_click", label);
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      onClick={onClick}
      className={className}
      {...rest}
    >
      {children || label}
    </a>
  );
}
